import * as React from "react"

import { NavLink } from "react-router-dom"
import { Menu, Icon } from "semantic-ui-react"
import { isSameLocation } from "../../../utils"

export interface IButtonLinkProps {
  children: React.ReactChildren | string
  to: string
  onClick?: (e: any) => void
  onClose?: (e: any) => void
  formId?: any
  className?: string
  oneLine?: boolean
}

const ButtonLink = ({
  children,
  to,
  onClick,
  onClose,
  formId,
  className = "",
  oneLine = false
}: IButtonLinkProps) => {
  const handleClose = (e: any) => {
    e.preventDefault()
    if (onClose) {
      onClose(formId)
    }
  }

  const textClassName = oneLine ? "header-link-text" : ""

  return (
    <NavLink to={to} onClick={onClick}>
      <Menu.Item
        active={isSameLocation(window.location.pathname, to)}
        className={className}
      >
        <span className={textClassName} >
          {children}
        </span>
        {formId ? (
          <Icon
            name="close"
            onClick={handleClose}
            style={{ marginBottom: 1 }}
          />
        ) : (
          ""
        )}
      </Menu.Item>
    </NavLink>
  )
}

export default ButtonLink
